module.exports = __webpack_public_path__ + "34736292/img/google.68f3823e.svg";